import { defineBlock } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Team members",
  category: "common",
  icon: "editor-ul",
  keywords: ["team", "people"],
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
  },
}

export default defineBlock("general/team-members", (props) => {
  return (
    <div className="grid-auto my-4">
      {props.teamMembers?.map((teamMember, i) => (
        <div className="col-span-12 md:col-span-10 md:col-start-2 lg:col-span-8 lg:col-start-3" key={i}>
          <div className="w-full flex flex-col bg-light-grey p-5 gap-2 justify-between items-start rounded-xl my-1 lg:flex-row lg:items-center">
            <h5 className="!type-title-xs text-dark-grey">{teamMember?.name}</h5>
            <span className="type-label-caps text-right">{teamMember?.position}</span>
          </div>
        </div>
      ))}
    </div>
  )
})
